import { Injectable } from '@angular/core';
import {  HttpRequest,  HttpHandler,  HttpEvent,  HttpInterceptor} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor  implements HttpInterceptor {

  constructor(public auth: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authRequest = request.clone();
    if (!request.headers.get('Authorization')) {
      const authToken = this.auth.getToken();
       authRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });   
    }
    return next.handle(authRequest);
   
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/interceptors/auth.interceptor.ts